module.exports = __webpack_public_path__ + "static/assets/10db5ce4c37ebd51abc46eb6840d4cfa.svg";